const $ = jQuery;

export default function () {
    const $map = $('section.map');

    if ($map.length === 0) return;

    const $pins = $map.find('.js-map--pin');
    const $items = $map.find('.js-map--item');

    const setActive = (index) => {
        $pins.removeClass('active');
        $items.removeClass('active');
        $pins.filter(`[data-index="${index}"]`).addClass('active');
        $items.filter(`[data-index="${index}"]`).addClass('active');
    };

    const removeActive = () => {
        $pins.removeClass('active');
        $items.removeClass('active');
    };

    $items.on('mouseenter', function () {
        const index = $(this).data('index');
        setActive(index);
    });

    // $items.on('mouseleave', removeActive);

    // $pins.on('mouseenter', function () {
    //     const index = $(this).data('index');
    //     setActive(index);
    // });

    // $pins.on('mouseleave', removeActive);

    if ($pins.length > 0) {
        setActive(0);
    }
}
